/** A line of words that names the called measures (CALL_NAME): each name is a glossary term with its popover, the rest stays plain text. */
import { Fragment, type ReactNode } from "react";
import { GxKpiLabel } from "../../theme/GxTerm";
import { CALL_NAME } from "./guided";

const NAMES = Object.entries(CALL_NAME) as readonly (readonly [keyof typeof CALL_NAME, string])[];

export function GxCallText({ children }: { readonly children: string }) {
  const parts: ReactNode[] = [];
  let rest = children, key = 0;
  while (rest !== "") {
    const hit = NAMES.map(([kpi, name]) => ({ kpi, name, at: rest.indexOf(name) })).filter((h) => h.at >= 0).sort((a, b) => a.at - b.at)[0];
    if (hit === undefined) { parts.push(<Fragment key={key++}>{rest}</Fragment>); break; }
    parts.push(<Fragment key={key++}>{rest.slice(0, hit.at)}</Fragment>, <GxKpiLabel key={key++} kpi={hit.kpi}>{hit.name}</GxKpiLabel>);
    rest = rest.slice(hit.at + hit.name.length);
  }
  return <>{parts}</>;
}
